var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"menuListLink",on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("icon"),_c('div',{staticClass:"menuListLink__text"},[_vm._v(_vm._s(_vm.text))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }